// eslint-disable-next-line no-restricted-imports
import superjson, { SuperJSON, parse } from "superjson";
import { DateZone, DateTime, Duration } from "./luxon";

// Register order matters! First registered is the first to be used.
SuperJSON.registerCustom<DateTime<true>, string>(
    {
        isApplicable: (v): v is DateTime<true> =>
            DateTime.isDateTime(v) &&
            v.isValid &&
            v.zone.type === DateZone.instance.type,
        serialize: (v) => {
            if (!v.isValid) {
                throw new Error(
                    "[superjson] Invalid DateTime for serialization: " + v
                );
            }
            return (v as DateTime<true>).toISODate();
        },
        deserialize: (v) => {
            const date = DateTime.fromISO(v).setZone(DateZone.instance);
            if (!date.isValid) {
                throw new Error(
                    "[superjson] Invalid date string for deserialization: " + v
                );
            }
            return date;
        },
    },
    "luxon.Date"
);

SuperJSON.registerCustom<DateTime<true>, string>(
    {
        isApplicable: (v): v is DateTime<true> =>
            DateTime.isDateTime(v) && v.isValid,
        serialize: (v) => {
            if (!v.isValid) {
                throw new Error(
                    "[superjson] Invalid DateTime for serialization: " + v
                );
            }
            return (v as DateTime<true>).toISO();
        },
        deserialize: (v) => {
            const date = DateTime.fromISO(v);
            if (!date.isValid) {
                throw new Error(
                    "[superjson] Invalid date string for deserialization: " + v
                );
            }
            return date;
        },
    },
    "luxon.DateTime"
);

SuperJSON.registerCustom<Duration<true>, string>(
    {
        isApplicable: (v): v is Duration<true> =>
            Duration.isDuration(v) && v.isValid,
        serialize: (v) => {
            if (!v.isValid) {
                throw new Error(
                    "[superjson] Invalid duration for serialization: " + v
                );
            }
            return (v as Duration<true>).toISO();
        },
        deserialize: (v) => {
            const duration = Duration.fromISO(v);
            if (!duration.isValid) {
                throw new Error(
                    "[superjson] Invalid duration string for deserialization: " +
                        v
                );
            }
            return duration;
        },
    },
    "luxon.Duration"
);

/**
 * Same as superjson.parse, but also allows normal JSON values.
 */
export const safeParse = <T = unknown>(value: string): T => {
    const res = parse<T>(value);

    // if res is undefined, the parse failed, since vanilla JSON doesn't support undefined and would have returned null.
    if (res !== undefined) return res;
    return parse<T>(superjson.stringify(JSON.parse(value)));
};

superjson.parse = safeParse;

export default superjson;
// eslint-disable-next-line no-restricted-imports
export * from "superjson";
export { safeParse as parse };
